export default () => [
  {
    type: 'checkbox',
    align: 'center',
    width: 40,
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 50,
    slots: {
      default: 'opt',
    },
  },
  {
    type: 'expand',
    align: 'center',
    width: 60,
    title: '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    field: 'feeNameText',
    align: 'center',
    minWidth: 100,
    title: '费用类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'priceTypeText',
    align: 'center',
    width: 100,
    title: '计费方式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'chargeUnitText',
    align: 'center',
    width: 100,
    title: '计费单位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'chargeFormulaText',
    align: 'center',
    width: 100,
    title: '计算公式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'basePrice',
    align: 'center',
    width: 100,
    title: '起步价/比例',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'feeRemark',
    align: 'center',
    minWidth: 150,
    title: '备注',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'isLineFeeText',
    align: 'center',
    width: 100,
    title: '是否关联线路',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPointName',
    align: 'center',
    minWidth: 170,
    title: '发货方名称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'origin',
    align: 'center',
    minWidth: 150,
    title: '始发地',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'destPointName',
    align: 'center',
    minWidth: 170,
    title: '收货方名称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'dest',
    align: 'center',
    minWidth: 150,
    title: '目的地',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
]
